import React from 'react';
import { useSelector } from 'react-redux';

import { Station } from '@travel/icons/service';
import { IconText } from '@travel/ui';
import { cx, isNotEmptyArray } from '@travel/utils';

import Transportation from 'components/Transportation';

import { getItem } from 'store/providerInformation/selectors';

import { Translate } from 'core/translate';
import { NearbyTerminal } from 'ProviderInformation-Types';

import styles from './overview.module.scss';

function NearbyTerminalItem({ name, transportation, time }: NearbyTerminal) {
  return (
    <div className={styles.nearbyTerminalItemWrapper}>
      <IconText
        icon={<Station size={20} />} //TODO: update when nearby terminal API is ready TIDP-24392
        text={name}
        textClassName={styles.nearbyTerminalName}
        spaceBetween={4}
      />
      <Transportation
        className={styles.transportation}
        transportation={transportation}
        time={time}
      />
    </div>
  );
}

function OverviewAccess() {
  const nearbyTerminals = useSelector(getItem).nearbyTerminals?.slice(0, 3);

  return isNotEmptyArray(nearbyTerminals) ? (
    <div
      className={cx(styles.overviewInfoContainer, styles.overviewAccessWrapper)}
      data-testid="overview-access-wrapper"
    >
      <h3 className={styles.blockTitle}>
        <Translate id="Provider_Info.Navigation.Access" />
      </h3>
      {nearbyTerminals.map(terminal => (
        <NearbyTerminalItem key={terminal.name} {...terminal} />
      ))}
    </div>
  ) : null;
}

export default OverviewAccess;
